/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Takeofflinetitle2Inputs */

const en_takeofflinetitle2 = /** @type {(inputs: Takeofflinetitle2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Take ${i?.name} offline?`)
};

const de_takeofflinetitle2 = /** @type {(inputs: Takeofflinetitle2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} offline nehmen?`)
};

/**
* | output |
* | --- |
* | "Take {name} offline?" |
*
* @param {Takeofflinetitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const takeofflinetitle2 = /** @type {((inputs: Takeofflinetitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Takeofflinetitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_takeofflinetitle2(inputs)
	return de_takeofflinetitle2(inputs)
});
export { takeofflinetitle2 as "takeOfflineTitle" }